import app from '../../scripts/app';
import template from './segment-banner.jade';
import segmentBannerCtrl from './segment-banner.controller';

app.directive('cianAfSegmentBanner', () => {
  return {
    template,
    scope: {},
    bindToController: {
      onClose: '&'
    },
    controller: segmentBannerCtrl,
    controllerAs: 'segmentBannerCtrl',
    transclude: true
  };
});
